// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SubProductCode = {};

SubProductCode.getSubProductCodeList = function (userInput) {
  return lossClient({
    url: "/SubProductType/search?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default SubProductCode;
